import { Center, Flex } from '@chakra-ui/react';
import { Form } from "../../components/Input/Form";

export const AddBlog = () => {
    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 25}}>
            <Form />
        </div>
    )
}